import { forEach, remove, assign } from 'lodash';
import anime from 'animejs';
import $ from 'shared/$';

// import Viewport from 'shared/viewport.js';

export default class NavMobile {
  constructor(root) {
    this.root = root;
    this.toggler = this.root.querySelector('[data-nav-trigger]');
    this.container = this.root.querySelector('[data-nav-target]');
    this.scrollable = this.container.querySelector('.u-nav-mobile__scrollable');
    this.panel = this.container.querySelector('.u-nav-mobile-level[data-nav-level="0"]');
    this.items = this.container.querySelectorAll('.u-nav-item');
    this.links = this.container.querySelectorAll('.u-nav-item > a');
    this.backBtn = this.container.querySelectorAll('[data-back]');

    this.isOpen = false;
    this.current = null;
    this.previous = null;
    this.level = 0;

    this.container.style.display = 'block';

    this.bind();
  }

  bind() {
    this.toggle = this.toggle.bind(this);
    this.onLiClick = this.onLiClick.bind(this);
    this.prevLevel = this.prevLevel.bind(this);

    this.toggler.addEventListener('click', this.toggle);

    forEach(this.links, link => {
      link.addEventListener('click', this.onLiClick);
    });

    forEach(this.backBtn, btn => {
      btn.addEventListener('click', this.prevLevel);
    });
  }

  destroy() {
    this.toggler.removeEventListener('click', this.toggle);

    forEach(this.links, li => {
      li.removeEventListener('click', this.onLiClick);
    });

    forEach(this.backBtn, btn => {
      btn.removeEventListener('click', this.prevLevel);
    });

    this.close();
    this.container.style.display = '';
    this.panel.style.transform = '';

    forEach(this.getLevelEls(), l => {
      l.removeAttribute('style');
    });
  }

  toggle() {
    this[this.isOpen ? 'close' : 'open']();
  }

  open() {
    document.body.classList.add('menu-open');
    this.toggler.classList.add('is-open');
    this.checkActive();
    this.container.classList.add('is-open');
    this.isOpen = true;
  }

  close() {
    document.body.classList.remove('menu-open');
    this.toggler.classList.remove('is-open');
    this.container.classList.remove('is-open');
    this.isOpen = false;
    forEach(this.items, item => {
      item.style.display = 'block';
    });
    forEach(this.container.querySelectorAll('.u-nav-card'), card => {
      card.style.display = 'block';
    });
    this.setLevel({
      level: 0,
      duration: 1,
    });
  }

  onLiClick(e) {
    const target = e.currentTarget;
    const li = target.parentNode;
    const level = li.querySelector('[class*="u-nav-mobile-level"]');

    if (level) {
      e.preventDefault();

      this.previous = this.current;
      this.current = li;

      level.style.display = 'block';

      this.nextLevel();
    } else {
      this.close();
    }
  }

  setLevel(opts = {}) {
    const options = assign(
      {
        dir: 'none',
        level: this.level,
        duration: 200,
      },
      opts
    );

    options.level = parseInt(options.level);

    // Scroll top
    this.scrollable.scrollTop = 0;

    // Prevent "ghost" scroll from ancestors
    if (options.dir === 'prev') {
      // Show previously hidden siblings items
      forEach($.siblings(this.previous), item => {
        item.style.display = 'block';
      });
      // Show previously hidden .u-nav-card
      if (this.current && this.current.querySelector('.u-nav-card[data-nav-level="1"]')) {
        this.current.querySelector('.u-nav-card[data-nav-level="1"]').style.display = 'block';
      }
    }
    // End prevent

    const anim = anime({
      targets: this.panel,
      translateX: `-${options.level * 100}%`,
      duration: options.duration,
      easing: 'easeOutExpo',
    });

    anim.finished.then(() => {
      // Hide "descendants" levels
      this.hideLevelEls({
        level: options.level + 1,
        not: options.level,
      });

      // Prevent "ghost" scroll from ancestors
      if (options.dir === 'next') {
        // Hide all siblings items
        forEach($.siblings(this.current), item => {
          item.style.display = 'none';
        });
        // Check if some parent .u-nav-card
        if (this.previous && this.previous.querySelector('.u-nav-card[data-nav-level="1"]')) {
          this.previous.querySelector('.u-nav-card[data-nav-level="1"]').style.display = 'none';
        }
      }
      // End prevent
    });

    this.level = options.level;
  }

  nextLevel() {
    this.setLevel({
      dir: 'next',
      level: this.level + 1,
    });
  }

  prevLevel(e) {
    e && e.preventDefault && e.preventDefault();

    this.previous = this.current;
    this.current = $.parents(this.current, 'u-nav-item');

    this.setLevel({
      dir: 'prev',
      level: this.level - 1,
    });
  }

  updateLevelEls() {}

  hideLevelEls(opts = {}) {
    const els = this.getLevelEls(opts);
    forEach(els, l => (l.style.display = 'none'));
  }

  getLevelEls(opts = {}) {
    // Node Elements to array, so we can use lodash .remove
    let levels = [...this.container.querySelectorAll('[class*="u-nav-mobile-level"]')];

    // Filter by the given level
    if (opts.level) {
      remove(levels, level => {
        return level.dataset.navLevel != opts.level; // eslint-disable-line eqeqeq
      });
    }

    if (opts.not) {
      remove(levels, level => {
        return level === opts.not;
      });
    }

    return levels;
  }

  getLevelParents(el) {
    let levels = [];

    const isLevel = el => {
      return el && el.dataset && el.dataset.navLevel;
    };

    while (el) {
      if (isLevel(el)) {
        levels.push(el);
      }

      el = el.parentNode;
    }

    return levels;
  }

  /**
   * When opening the menu, check the active classes
   * in order to display the correct level.
   */
  checkActive() {
    const actives = this.container.querySelectorAll('.u-nav-item.is-active');

    if (!actives.length) {
      return;
    }

    console.info('actives', actives);

    // last is always the deep level, right?
    const last = actives[actives.length - 1];
    const targetLevel = last.querySelector('[class*="u-nav-mobile-level"][data-nav-level]');

    if (!targetLevel || !targetLevel.dataset.navLevel) {
      return;
    }

    const levelIndex = targetLevel.dataset.navLevel;
    this.current = last;

    forEach(this.getLevelEls(), l => {
      l.style.display = 'none';
    });

    forEach(this.getLevelParents(targetLevel), l => {
      l.style.display = 'block';
    });

    this.setLevel({
      dir: 'next',
      level: levelIndex,
      duration: 1,
    });
  }
}
